/* eslint-disable import/no-default-export */
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import Icon, { IconColor, IconName } from 'common/components/controls/icon';
import React from 'react';
import styles from './board-buttons.less';

export interface HeaderButton {
  className: string;
  icon?: IconName;
  iconColor?: IconColor;
  iconLarge?: boolean;
  onClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
  tabIndex?: number;
  title: string;
}

function onFocusChange(e: React.FocusEvent) {
  e.stopPropagation();
}

export const BoardHeaderButton: React.FunctionComponent<HeaderButton> = ({
  children,
  className,
  icon,
  iconColor,
  iconLarge,
  onClick,
  tabIndex,
  title,
}) => (
  <button
    className={classNames(styles.button, className)}
    onFocus={onFocusChange}
    onBlur={onFocusChange}
    onClick={onClick}
    tabIndex={tabIndex}
    title={title}
  >
    {icon && (
      <Icon
        color={iconColor}
        name={icon}
        large={iconLarge}
        small={!iconLarge}
        className={children && icon ? styles.iconWithPadding : ''}
      />
    )}
    {children}
  </button>
);

export default BoardHeaderButton;



// WEBPACK FOOTER //
// ./app/gamma/src/components/board-buttons/button.tsx